// @flow
import PropTypes         from 'prop-types';
import randomInt         from 'random-int';
import type { Resource } from './resource.types';
import { userShape }     from './user';
import randomString      from '../utils/randomString';

export type ServiceReview = Resource<{}>;

const serviceReviewShape = {
  '@id':   PropTypes.string.isRequired,
  '@type': PropTypes.string.isRequired,
  id:      PropTypes.string.isRequired,
  author:  PropTypes.shape(userShape).isRequired,
  body:    PropTypes.string,
  rating:  PropTypes.number,
};


const serviceReviewPropType = PropTypes.shape(serviceReviewShape);


const generateMockServiceReview = () => {

  const id = randomString(32);

  return {
    '@id':   '/service_reviews/' + id,
    '@type': 'http://schema.org/Thing',
    id:      id,
    author:  require('./user').generateMockUser(),
    body:    Array(/* word count */ randomInt(3, 30)).map(() => randomString(randomInt(12))).join(' '),
    rating:  randomInt(5),

  };

};


export {
  serviceReviewShape,
  serviceReviewPropType,
  generateMockServiceReview
};


// WEBPACK FOOTER //
// ./src/domain/serviceReview.js